
import React, { useEffect, useRef, useState, Fragment } from "react";
import ReactDOM from "react-dom"
import { List, ListItemProps } from "semantic-ui-react";

const useKeyPress = function (targetKey: string) {
    const [keyPressed, setKeyPressed] = useState(false);

    function downHandler({ key }: KeyboardEvent) {
        if (key === targetKey) {
            setKeyPressed(true);
        }
    }

    const upHandler = ({ key, target }: KeyboardEvent) => {

        if (key === targetKey) {
            setKeyPressed(false);
        }
    };

    React.useEffect(() => {
        window.addEventListener("keydown", downHandler);
        window.addEventListener("keyup", upHandler);

        return () => {
            window.removeEventListener("keydown", downHandler);
            window.removeEventListener("keyup", upHandler);
        };
    });

    return keyPressed;
};

export const TimeList: React.FC<{
    list: any[];
    onSelect: any;
    selected: any;
    label?: string
}> = ({ list, selected, onSelect, label }) => {

    const listRef = useRef(null);
    const selectedItemRef = useRef(null);

    // const downPress = useKeyPress("ArrowDown");
    // const upPress = useKeyPress("ArrowUp");
    // const enterPress = useKeyPress("Enter");

    /*
        const [cursor, setCursor] = useState<number | undefined>(undefined);
        const [hovered, setHovered] = useState(undefined);
        const [listFocus, setListFocus] = useState<boolean>(false);
    
        useEffect(() => {
            if (list.length && downPress && listFocus) {
                setCursor((prevState = 0) =>
                    prevState < list.length - 1 ? prevState + 1 : prevState
                );
            }
        }, [downPress,]);
    
        useEffect(() => {
            if (list.length && upPress && listFocus) {
                setCursor((prevState = 0) => (prevState > 0 ? prevState - 1 : prevState));
            }
        }, [upPress]);
    
        useEffect(() => {
            if (list.length && enterPress && listFocus && cursor) {
                onSelect(list[cursor].value);
            }
        }, [cursor, enterPress]);
    
        useEffect(() => {
            if (list.length && hovered && listFocus) {
                setCursor(list.indexOf(hovered));
            }
        }, [hovered]);
    */

    useEffect(() => {
        const itemEl = ReactDOM.findDOMNode(listRef.current) as HTMLElement | undefined;
        const selectedEL = ReactDOM.findDOMNode(selectedItemRef.current) as HTMLElement | undefined;;
        if (itemEl && selectedEL) {
            itemEl.scrollTop = selectedEL.offsetTop - 30
        }
    }, [selected]);

    const _onClick = (_1: any, data: ListItemProps) => {
        onSelect(data.value)
    };


    return (
        <Fragment>
            <div className="TimeList_header" >{label}</div>
            <List
                //  tabindex={-0}
                //  onFocus={() => setListFocus(true)}
                //  onBlur={() => setListFocus(false)}
                ref={listRef}
                id="hours"
                className="TimeList"
                celled
                selection
            >


                {list.map((item, i) => (
                    <List.Item

                        ref={selected === item.value ? selectedItemRef : undefined}
                        className="TimeListItem"
                        key={item.key}
                        value={item.value}
                        onClick={_onClick}
                        // active={i === cursor}
                        //    style={typeof cursor !== undefined && i === cursor ? { backgaudit: "rgba(0, 0, 0, 0.03)", color: "rgba(0, 0, 0, 0.8)" } : {}}

                        //   onMouseEnter={() => setHovered(item)}
                        //    onMouseLeave={() => setHovered(undefined)}
                        active={selected === item.value}
                    >
                        {item.text}
                    </List.Item>
                ))
                }
            </List >
        </Fragment>

    )
};